import { FilterFieldDefinition } from '../../composables/useUrlFilters';
import { UrlFilterSerializer } from '../UrlFilterSerializer';

export const MarketplaceOrderFilterDefinitions: FilterFieldDefinition[] = [
    {
        key: 'orderId',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'orderNumber',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'marketplaceCode',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.marketplaceOptions?.some((opt: any) => opt.code === value) ?? false;
        }
    },
    {
        key: 'orderStatus',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.orderStatusOptions?.some((opt: any) => opt.value === value) ?? false;
        }
    },
    {
        key: 'refundStatus',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.refundStatusOptions?.some((opt: any) => opt.value === value) ?? false;
        }
    },
    {
        key: 'paymentStatus',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            return context?.paymentStatusOptions?.some((opt: any) => opt.value === value) ?? false;
        }
    },
    {
        key: 'orderBalanceSign',
        type: 'dropdown',
        defaultValue: null,
        validate: (value, context) => {
            const validValues = ['positive', 'negative', 'zero', 'non-zero'];
            return validValues.includes(value);
        }
    },
    {
        key: 'remarks',
        type: 'text',
        defaultValue: null
    },
    {
        key: 'dateOrderOnFrom',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    },
    {
        key: 'dateOrderOnTo',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    }
];
